import * as Sentry from '@sentry/react'

/**
 * Fonction centrale de logging d'erreurs
 * Log dans la console en dev, envoie à Sentry en prod
 */
export function logError(error, context = {}) {
  console.error('[Flashia]', error, context)
  if (import.meta.env.PROD) {
    Sentry.withScope(scope => {
      Object.entries(context).forEach(([key, val]) => scope.setExtra(key, val))
      if (error instanceof Error) {
        Sentry.captureException(error)
      } else {
        Sentry.captureMessage(String(error), 'error')
      }
    })
  }
}

/**
 * Log un warning (non-bloquant)
 */
export function logWarn(message, context = {}) {
  console.warn('[Flashia]', message, context)
  if (import.meta.env.PROD) {
    Sentry.withScope(scope => {
      Object.entries(context).forEach(([key, val]) => scope.setExtra(key, val))
      Sentry.captureMessage(String(message), 'warning')
    })
  }
}
